import { RemoteGetAllShifts } from 'data/usecases';
import { GetAllShiftsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlShifts } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllShifts = (): GetAllShiftsUseCaseInterface =>
  new RemoteGetAllShifts(makeApiUrlShifts(), makeAxiosHttpClient());
